import { FulfillmentMethod } from "@aitisal/contracts/common";
import { getNearestBranch } from "@aitisal/sdk/restaurant";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import "../../App.css";
import AppLayout from "../../components/AppLayout";
import Footer from "../../components/Footer/Footer";
import { LoadingOverlay } from "../../components/ui/LoadingOverlay";
import { ThemeSlot } from "../../themes/slots";
import { useSession } from "../../stores/sessionStore";
import { useRestuarantDetails } from "../../stores/stores";

export const Route = createFileRoute("/c/_menuLayout")({
  component: RouteComponent,
});

function RouteComponent() {
  const {
    latitude,
    longitude,
    brandId,
    setLatitude,
    setLongitude,
    setPersonAddress,
    setIsPickup,
    setFullfillmentType,
    setRestaurantId,
    setRestaurantAreaId,
    restaurantId,
  }: any = useSession();

  const { setRestaurant } = useRestuarantDetails();

  // Resolve nearest branch when no restaurant has been chosen yet
  const { data: nearestRestaurant, isError: nearestRestaurantError } = useQuery(
    {
      queryKey: ["nearest-restaurant", latitude, longitude, brandId],
      queryFn: async () => {
        if (!brandId) {
          return null;
        }
        const response: any = await getNearestBranch(
          brandId,
          (latitude === 0 && longitude === 0) || (!latitude && !longitude)
            ? {}
            : {
              lat: latitude,
              lng: longitude,
            }
        );
        return response?.data;
      },
      enabled: Boolean(brandId) && !restaurantId,
      retry: 1,
    }
  );

  useEffect(() => {
    if (restaurantId) return;
    const branch = nearestRestaurant?.branch;
    const restaurantAreaId = nearestRestaurant?.restaurantAreaId;
    if (branch && branch.restaurantId) {
      setRestaurant(branch);
      setRestaurantId(branch.restaurantId);
      setRestaurantAreaId(restaurantAreaId);
    } else if (nearestRestaurantError) {
      setLatitude(null);
      setLongitude(null);
      setPersonAddress(null);
      setIsPickup(false);
      setFullfillmentType(FulfillmentMethod.BRANCH_DELIVERY);
    }
  }, [
    nearestRestaurant,
    nearestRestaurantError,
    restaurantId,
    setFullfillmentType,
    setIsPickup,
    setLatitude,
    setLongitude,
    setPersonAddress,
    setRestaurant,
    setRestaurantAreaId,
    setRestaurantId,
  ]);

  return (
    <AppLayout>
      <ThemeSlot slot="header" isMenu={true} isAddressRequired={false} />
      {restaurantId ? (
        <ThemeSlot slot="homePage" />
      ) : (
        <main className="flex h-screen flex-col items-center justify-center">
          <div className="min-h-screen flex flex-col items-center justify-center bg-white">
            <LoadingOverlay
              visible={true}
              zIndex={1000}
              loaderProps={{ color: "var(--brand-color)" }}
              overlayProps={{ radius: "sm", blur: 2 }}
            />
          </div>
        </main>
      )}
      <Footer />
      <Outlet />
    </AppLayout>
  );
}